import { returnAllTradeDetailsFromGenericParams } from "@/lib/agGridColDefs/colDefGlobalHelpers";
import { returnSizeFormatted } from "@/lib/globalFormatterHelper";
import tradeDataStore from "@/store/tradeDataStore";
import { getLegSummaryDataFromStore } from "./fillsSummaryHelpers";

/**
 * FillsSummaryQuantityCellRenderer
 *
 * Displays the total filled quantity at the leg level in MM/M format.
 * - Main display: Shows block value from API (current server state)
 * - Tooltip: Handled by tooltipValueGetter on the column definition
 */
const FillsSummaryQuantityCellRenderer = (params: any) => {
  // Subscribe to Zustand store for reactive updates (hooks must run before any early return)
  tradeDataStore((state) => state.tradeData);

  if (!params.data) {
    return null;
  }

  const { fullTradeData } = returnAllTradeDetailsFromGenericParams(params);
  const esid = fullTradeData?.esid;
  const blockId = params.data?.blockId;

  let fillQuantity: number | null = null;
  let instrumentType: string | undefined = undefined;

  if (esid && blockId !== undefined) {
    const legData = getLegSummaryDataFromStore(esid, blockId, params.data);
    fillQuantity = legData.fillQuantity;
    instrumentType = legData.instrumentType;
  }

  // Fallback instrumentType from params.data if not in store
  if (!instrumentType) {
    instrumentType = params.data?.instrumentType;
  }

  // Format the quantity with MM/M notation
  const displayValue =
    fillQuantity && fillQuantity > 0
      ? returnSizeFormatted(fillQuantity, instrumentType)
      : "";

  return (
    <div
      data-testid="fillsSummaryQuantityCellContainer"
      id="fillsSummaryQuantityCellContainer"
      className="justify-center text-center"
      style={{ width: "100%" }}
    >
      {displayValue}
    </div>
  );
};

export default FillsSummaryQuantityCellRenderer;

/**
 * AG Grid valueFormatter for copy/paste functionality.
 * Returns the fillQuantity from the legs array.
 */
export function fillsSummaryQuantityValueFormatter(params: any): string {
  if (!params.data) {
    return "";
  }

  const { fullTradeData } = returnAllTradeDetailsFromGenericParams(params);
  const esid = fullTradeData?.esid;
  const blockId = params.data?.blockId;

  if (!esid || blockId === undefined) {
    return "";
  }

  const legData = getLegSummaryDataFromStore(esid, blockId, params.data);
  const fillQuantity = legData.fillQuantity;

  return fillQuantity && fillQuantity > 0 ? `${fillQuantity} ` : "";
}
